import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, mediaUrl, fmtDate, HTML_LANG } from "../../lib/blogApi";

export const RelatedPosts = ({ slug, no }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems([]);
    axios.get(`${API}/blogdata/posts/${slug}/related`).then(({ data }) => setItems(data)).catch(() => {});
  }, [slug]);
  if (!items.length) return null;
  return (
    <section data-testid="blog-related" aria-labelledby="related-h" className="mt-16 border-t-2 border-ink pt-8">
      <h2 id="related-h" className="font-mono text-[12px] tracking-[0.22em] uppercase text-ember">{no ? "Les også" : "Read next"}</h2>
      <ul className="mt-6 grid gap-8 md:grid-cols-3">
        {items.map((p, i) => {
          const img = p.cover_media_id ? mediaUrl(p.cover_media_id) : p.cover_url;
          return (
            <li key={p.slug} lang={HTML_LANG[p.lang]} data-testid={`blog-related-item-${i}`} className="group flex flex-col">
              {img && <img src={img} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }}
                className="w-full h-36 object-cover border border-ink mb-4 transition-opacity group-hover:opacity-90" />}
              <time dateTime={p.published_at} className="font-mono text-[12px] tracking-[0.1em] uppercase text-mist">
                {fmtDate(p.published_at, p.lang)}{p.reading_min ? ` · ${p.reading_min} min` : ""}
              </time>
              <h3 className="mt-2 font-serif text-xl leading-snug">
                <Link to={`/blog/${p.slug}`} data-testid={`blog-related-link-${i}`}
                  className="underline-offset-4 hover:underline hover:text-ember transition-colors">{p.title}</Link>
              </h3>
              {p.excerpt && <p className="mt-2 text-[15px] leading-relaxed line-clamp-3">{p.excerpt}</p>}
            </li>
          );
        })}
      </ul>
    </section>
  );
};
